import {
  PROFILE_INFO_URI,
  PROFILE_INFO_URI_COMPANIES,
  SAVE_LOGIN_TOKEN,
  UPDATE_PROFILE_URI,
} from '../common/endpoints';
import { get, post } from '../common/axiosInstance';

import { PROFILE_OPERATION_TYPE } from '../../common/constants';
import { companiesResponseTransformer } from './userCompanies.transformer';
import { getProfileByType } from '../../chatgpt_summarize/utils';

const companiesInfo = function () {
  // gets the profile info
  this.getProfileInfo = async function (params, callback) {
    const response = await get(PROFILE_INFO_URI_COMPANIES('companies'));
    const favData = await getProfileByType('favourites');
    callback(
      companiesResponseTransformer(
        response?.data['profileFieldName'],
        favData?.data['profileFieldName'],
      ),
    );
  };

  // TODO:: check security risk for this API
  // updates the profile info with any data parameter

  this.profileOperation = ({ params, callbackFn, profileOperationType }) => {
    switch (profileOperationType) {
      case PROFILE_OPERATION_TYPE.getProfileInfo:
        return this.getProfileInfo(params, callbackFn);
      default:
        return this.getProfileInfo(params, callbackFn);
    }
  };
};

export const companiesHandler = new companiesInfo().profileOperation;
